// colour palette for charts
export const COLOR_ARRAY: string[] = [
  '#FF5733',
  '#33FF57',
  '#3357FF',
  '#FF33A1',
  '#FF8C33',
  '#A833FF',
  '#33FFF6',
  '#D4FF33',
  '#FF335E',
  '#33FF90',
  '#7A33FF',
  '#FF3362',
  '#FFB833',
  '#33FFAB',
  '#5133FF',
  '#FF334F',
  '#33E4FF',
  '#FF33D1',
  '#78FF33',
  '#FF3355',
  '#FF6633',
  '#33FFC1',
  '#9933FF',
  '#FF3388',
  '#33FF48',
  '#FF3344',
  '#33FFDE',
  '#AC33FF',
  '#FF33BB',
  '#33FF6C',
]
